<template>
<div>
  <el-form style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="120px" class="demo-ruleForm">
    <el-form-item label="设备编号" prop="device_id">
      <span v-if="!addEditObj.isBind">{{addEditForm.deviceid}}</span>
      <el-autocomplete v-else v-fixZoom :disabled="!isBind" style="width: 100%" class="inline-input" v-model="addEditForm.device_id"
                       :fetch-suggestions="querySearch" placeholder="请输入设备编号" :trigger-on-focus="false" @select="handleSelect">
      </el-autocomplete>
    </el-form-item>
    <el-form-item label="服务商人员" prop="sp_id">
      <el-select v-fixZoom v-model="addEditForm.sp_id" filterable placeholder="请选择" style="width: 100%">
        <el-option v-for="item in supplierorgpersons" :key="item.value" :label="item.name" :value="item.id">
          <span style="float: left">{{ item.name }}</span>
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="设备号码" prop="phone">
      <el-input style="width: 100%" placeholder="请输入设备号码" v-model="addEditForm.phone" :disabled="isEdit" autocomplete="off"></el-input>
    </el-form-item>
  </el-form>
  <div style="margin-top: 50px">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAdd()"><span>取消</span></div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEdit('addEditForm')"><span>确定</span></div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {searchunbinddevice} from '../../../api/device'
import {binddevicesupplier, editdevicesupplier} from '../../../api/yanglaoyuan'

export default {
  name: 'addEditDeviceNew',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    addEditObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isBind: true,
      isEdit: false, // 设备号码是否能修改
      addEditForm: {
        did: '',
        sp_id: '', // 人员id
        deviceid: '', // 设备imei
        phone: ''
      },
      addEditRules: {
        deviceid: [{ required: true, message: '请选择', trigger: 'change' }],
        phone: [{ required: true, message: '请输入设备号码', trigger: 'blur' }],
        sp_id: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      supplierorgpersons: [] // 服务商人员
    }
  },
  created () {
    this.supplierorgpersons = this.addEditObj.supplierorgpersons
    if (!this.addEditObj.isBind) {
      this.addEditForm.did = this.addEditObj.deviceRow.id
      this.addEditForm.sp_id = this.addEditObj.deviceRow.sp_id
      this.addEditForm.deviceid = this.addEditObj.deviceRow.deviceid
      this.addEditForm.phone = this.getDevicePhone(this.addEditObj.deviceRow)
    }
  },
  methods: {
    getDevicePhone (row) {
      if (row.simcardno !== '' && row.simcardno !== '<nil>') {
        return row.simcardno
      } else {
        return row.sp_phone
      }
    },
    querySearch (queryString, cb) {
      if (queryString.length < 4) {
        let arr = []
        cb(arr)
        return
      }
      searchunbinddevice({lessdeviceid: queryString}).then(res => {
        let re = []
        for (let i = 0; i < res.data.devices.length; i++) {
          if (this.radioType === 2) { // 绑定对象 1、老人设备管理。2、员工设备管理
            if (res.data.devices[i].devicetype === 300 || res.data.devices[i].devicetype === 310 || res.data.devices[i].devicetype === 311 ||
              res.data.devices[i].devicetype === 312 || res.data.devices[i].devicetype === 313 || res.data.devices[i].devicetype === 330 || res.data.devices[i].devicetype === 850 || res.data.devices[i].devicetype === 852) {
              re.push({
                value: res.data.devices[i].deviceid + '(' + this.getDtype(res.data.devices[i].devicetype) + ')',
                deviceid: res.data.devices[i].deviceid,
                dtype: res.data.devices[i].devicetype,
                id: res.data.devices[i].id,
                simcardno: res.data.devices[i].simcardno
              })
            }
          } else {
            re.push({
              value: res.data.devices[i].deviceid + '(' + this.getDtype(res.data.devices[i].devicetype) + ')',
              deviceid: res.data.devices[i].deviceid,
              dtype: res.data.devices[i].devicetype,
              id: res.data.devices[i].id,
              simcardno: res.data.devices[i].simcardno
            })
          }
        }
        cb(re)
      }).catch(() => {
        let arr = []
        cb(arr)
      })
    },
    handleSelect (item) {
      // console.log('item', item)
      this.addEditForm.did = item.id
      this.addEditForm.deviceid = item.deviceid
      this.addEditForm.phone = item.simcardno
      if (item.simcardno === '' || item.simcardno.length !== 11) {
        this.isEdit = false
      } else {
        this.isEdit = true
      }
    },
    getDtype (type) {
      if (type === 700) {
        return '智能网关'
      }
      return this.commonType.getDeviceType(type)
    },
    closeAdd () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      // console.log(111, this.addEditForm)
      this.$refs[formName].validate((valid) => {
        // console.log(222, this.addEditForm)
        if (valid) {
          let data = {
            did: this.addEditForm.did,
            sp_id: this.addEditForm.sp_id, // 人员id
            deviceid: this.addEditForm.deviceid, // 设备imei
            phone: this.addEditForm.phone
          }
          if (this.addEditObj.isBind) {
            binddevicesupplier(data).then(res => {
              this.$notify({ title: '成功', message: '成功绑定设备', type: 'success' })
              this.$emit('updateDevice')
              this.$emit('change', false)
            }).catch(() => {})
          } else {
            editdevicesupplier(data).then(res => {
              this.$notify({ title: '成功', message: '成功编辑设备', type: 'success' })
              this.$emit('updateDevice')
              this.$emit('change', false)
            }).catch(() => {})
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceComponents/addEditDeviceSupplier.vue